import { useCallback, useEffect, useState } from "react";
import useHttp from "hooks/use-http";
import { GetsitemapAllProductsRequest } from "api/requests";

export default function AccessoryAllProducts() {
  const { request } = useHttp();
  const [productData, setProductData] = useState({
    data: [],
    count: 0,
  });

  //////////////// Get All Products  ////////////////
  const getProducts = useCallback(async () => {
    const res = await request({
      url: GetsitemapAllProductsRequest,
    });

    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
      }));

      setProductData({
        data: transformedData,
        count: res.count,
      });
    }
  }, [request]);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  return (
    <>
      <div>{'<?xml version="1.0" encoding="UTF-8"?>'}</div>
      <div>
        {'<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">'}
      </div>
      <div>
        {"<url>" +
          "<loc>https://wewell.co.ir/</loc>" +
          "<changefreq>Daily</changefreq>" +
          "<priority>1.00</priority>" +
          "</url>"}
      </div>
      {productData.data?.map((product, index) => (
        <div key={index}>
          {"<url>" +
            `<loc>https://wewell.co.ir/#/product/${product?.id}</loc>` +
            `<changefreq>Daily</changefreq>` +
            `<priority>0.90</priority>` +
            "</url>"}
        </div>
      ))}
      <div>{"</urlset>"}</div>
    </>
  );
}
